import { SavedRoom } from "../../../../../models"

export const UPDATE_SAVED_ROOM = 'UPDATE_SAVED_ROOM'


export interface UpdateSavedRoomAction {
    type: string
    result: SavedRoom
}

export const updateSavedRoom = (result: SavedRoom): UpdateSavedRoomAction => ({
    type: UPDATE_SAVED_ROOM,
    result
})
